export default __webpack_public_path__ + "static/media/direct-download.6f86bcb1.svg";